import { useTranslations } from "../../hooks/useTranslations";
import Page from "../ui/Page";
import styles from "./Arbeitssicherheit.module.css";

const Arbeitssicherheit = () => {
  const { i18n } = useTranslations();
  return (
    <Page
      title={i18n.arbeitssicherheit.title}
      backLinkText={i18n.payrollBackLink}
      narrow={true}
    >
      <div>
        <p>
          {i18n.arbeitssicherheit.paragraph1}
          <br />
          {i18n.arbeitssicherheit.paragraph2}
        </p>
        <p>
          <a
            href="https://www.hgv.it/de/dienstleistungen/weiterbildung/arbeitssicherheit-fuer-arbeitnehmer"
            target="_blank"
          >
            {i18n.arbeitssicherheit.onlineCourse.linkLabel}
          </a>{" "}
          {i18n.arbeitssicherheit.onlineCourse.text}
        </p>
        <p>
          <a
            href="https://www.hgv.it/de/dienstleistungen/weiterbildung#c282"
            target="_blank"
          >
            {i18n.arbeitssicherheit.presenceCourse.linkLabel}
          </a>{" "}
          {i18n.arbeitssicherheit.presenceCourse.text}
        </p>
        <p className={styles.caption}>{i18n.arbeitssicherheit.asFrom}</p>
      </div>
    </Page>
  );
};

export default Arbeitssicherheit;
